import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/SEO';
import SiteLayout from '../components/SiteLayout';
import Hero from '../components/UseCases/Hero';
import Menu from '../components/UseCases/Menu';
import ContentBlocks from '../components/UseCases/ContentBlocks';
import ReadyToStartCTA from '../components/CTA/ReadyToStart';
import { StyledCTA } from '../components/UseCases/styles';

const UseCaseTemplate = ({
  location,
  data: {
    wpgraphql: {
      useCase: {
        acfUseCasesNavigation: menu,
        acfUseCases: { hero, contentBlocks },
        ...page
      },
    },
  },
}) => {

  return (
    <SiteLayout location={location}>
      <SEO page={page} path={location.pathname} />
      <Hero hero={hero}>
        <Menu menu={menu} pageUri={page.uri} />
      </Hero>
      <ContentBlocks blocks={contentBlocks} />

      <StyledCTA>
        <ReadyToStartCTA />
      </StyledCTA>
    </SiteLayout>
  );
};

export default UseCaseTemplate;

export const query = graphql`
  query GET_USECASE($id: ID!) {
    wpgraphql {
      useCase(id: $id) {
        uri
        ...UseCaseMenuFragment
        ...UseCaseSEOPageFragment
        ...UseCaseHeroFragment
        ...UseCaseMediaAndTextFragment
        ...UseCaseIconCardsFragment
        ...UseCaseImageCardsFragment
      }
    }
  }
`;
